import FourZeroFourError from './FourZeroFourError';
import FiveZeroZeroError from './FiveZeroZeroError';
import GenericError from './GenericError';
import { FC } from 'react';

export enum ErrorCode {
  NOT_FOUND = 404,
  INTERNAL_SERVER_ERROR = 500,
}

interface CustomErrorProps {
  code?: ErrorCode;
}

const Error: FC<CustomErrorProps> = ({ code }) => {
  switch (code) {
    case ErrorCode.NOT_FOUND:
      return <FourZeroFourError />;
    case ErrorCode.INTERNAL_SERVER_ERROR:
      return <FiveZeroZeroError />;
    default:
      return <GenericError />;
  }
};

export default Error;
